import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
} from "@chakra-ui/react";
import { Form, Formik, FormikErrors } from "formik";
import { useEffect, useRef, useState } from "react";
import {
  CampaignSchedule,
  FormType,
  RUN_TYPE,
} from "../../../common/types/campaign";
import { useSelector } from "react-redux";
import { selectCampaign } from "./campaignSlice";
import {
  ScheduleOnce,
  SchedulePeriodic,
  ScheduleRecurring,
} from "./components/SchedulerForms";
import { SCHEDULE_TYPES } from "../../../common/constants/campaign";
import DropdownWithSearch from "../../../components/DropdownWithSearch";
import { validateSchedule } from "./helper/validationHelper";
import { formatScheduleData, INIT_SCHEDULE } from "./helper/formatHelper";

export default function CampaignScheduleForms({
  data,
  onChange,
}: {
  onChange: (schedule: CampaignSchedule) => void;
  data: CampaignSchedule;
}) {
  const [initValues, setInitValues] = useState(formatScheduleData(null, null));
  const [initErrors, setInitErrors] = useState<FormikErrors<CampaignSchedule>>(
    {}
  );

  const { activeErrorCheck } = useSelector(selectCampaign);

  useEffect(() => {
    if (cancelButton.current !== null) {
      cancelButton.current.click();
    }
  }, [initValues]);

  useEffect(() => {
    setInitValues(data);
    activeErrorCheck && setInitErrors(validateSchedule(data));
  }, [activeErrorCheck, data]);

  const cancelButton = useRef<HTMLButtonElement>(null);

  function validate(values: CampaignSchedule, errorCheck: boolean) {
    formChanged(values);

    let errors: FormikErrors<CampaignSchedule> = {};

    if (!errorCheck) return errors;

    return validateSchedule(values);
  }

  function formFinder(form: FormType) {
    switch (form.values.run_type) {
      case RUN_TYPE.ONCE:
        return <ScheduleOnce form={form} />;
      case RUN_TYPE.PERIOD:
        return <SchedulePeriodic form={form} />;
      case RUN_TYPE.RECURRING:
        return <ScheduleRecurring form={form} />;
      case RUN_TYPE.AT_ONCE:
        return <></>;
    }
  }

  function formChanged(values: CampaignSchedule) {
    onChange(values);
  }

  return (
    <Box w="xl">
      <Text fontSize="sm" color="gray.600" mb="2">
        Select time and frequency for this journey
      </Text>

      <Formik
        enableReinitialize={true}
        initialValues={initValues}
        initialErrors={initErrors}
        validateOnChange={true}
        onSubmit={() => {}}
        validate={(values) => validate(values, activeErrorCheck)}
      >
        {(form) => (
          <Form id="settings-form" onSubmit={form.handleSubmit}>
            <FormControl
              mb="2"
              py="2"
              id="run_type"
              isInvalid={!!form.errors.run_type}
            >
              <FormLabel color="gray.500" fontSize="xs">
                Schedule type
              </FormLabel>
              <DropdownWithSearch
                options={SCHEDULE_TYPES}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.value}
                value={SCHEDULE_TYPES.find(
                  (type) => type.value === form.values.run_type
                )}
                onChange={(option) => {
                  form.setValues(
                    {
                      ...INIT_SCHEDULE,
                      run_type: option?.value as RUN_TYPE,
                    },
                    true
                  );
                }}
                isInvalid={!!form.errors.run_type}
              />
              <FormErrorMessage fontSize={12}>
                {form.errors.run_type}
              </FormErrorMessage>
            </FormControl>

            {formFinder(form)}
          </Form>
        )}
      </Formik>
    </Box>
  );
}
